module.exports = function () {
    if ($('.hero').length === 0) {
        return;
    }

    $('.hero.hero--animate').addClass('hero--is-animated');

    var adjustHeroWrapperMinHeight = function () {        
        $('.hero-content__feature-image').not('.hero-content__feature-image--cover').each(function () {

            var heroWrapper = $(this).closest('.hero__wrapper');

            var featureImageDivWidth = $(this).width();
            var featureImageHeight = $(this).data('imageHeight');
            var featureImageWidth = $(this).data('imageWidth');
            var newFeatureImageDivHeight = ((featureImageDivWidth) * (featureImageHeight / featureImageWidth))
            var featureImageDivMargin = $(this).outerHeight(true) - $(this).outerHeight();

            if (ICF.Utils.Breakpoints.IsAtLeastDesktopSm()) {                                                                
                var newHeroWrapperMinHeight = newFeatureImageDivHeight + featureImageDivMargin + "px";                
                heroWrapper.css('min-height', newHeroWrapperMinHeight);
            }
            else {
                heroWrapper.css('min-height', '');
            }            
        });
    };

    adjustHeroWrapperMinHeight();

    $(window).resize(function () {
        adjustHeroWrapperMinHeight();
    });

};